<template>
	<div style="width: 100%;">
        <el-row :gutter="20">
            <el-col :span="24" style="vertical-align:middle">
                <!-- <div class="grid-content bg-purple"></div> -->
                请选择区域:
                <el-select v-model="domain" filterable placeholder="请选择区域">
                    <el-option
                        v-for="item in serverItems"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-col>
        </el-row>

        <el-row :gutter="20" style="width: 100%; margin-top: 20px">
            <el-col :span="24">
                <el-card class="box-card1">
                    <div slot="header" class="clearfix">
                        <span>设备</span>
                    </div>
                    <component :is="device" :message="message"></component>
                </el-card>
            </el-col>
        </el-row>

        <el-row :gutter="20" style="width: 100%; margin-top: 20px">
            <el-col :span="24">
                <el-card class="box-card1">
                    <div slot="header" class="clearfix">
                        <span>会话</span>
                    </div>
                    <component :is="session" :message="message"></component>
                </el-card>
            </el-col>
        </el-row>
	</div>
</template>

<script>
import Device from '@/components/device/Device.vue'
import Session from '@/components/device/Session.vue'
import { Config } from "@/config/config"

export default {
    name: 'Area',
    components: {
        Device,
        Session
    },
    data() {
        return {
            domain: 'EU',
            serverItems: [],
            device: Device,
            session: Session,
            message: 'EU',
            activeName: 'first'
        }
    },
    created: function() {
        this.getDomainData()
    },
    mounted() {
        // this.getDomainData()
        console.log("serverItems in mounted:"+this.serverItems)
    },
    watch: {
        'domain' (newVal, oldVal) { //监听区域改变
            this.message = newVal
        }
    },
    methods: {
        handleClick() {
            // if (this.activeName === 'first') {
            // 	this.message = 'device'
            // } else if (this.activeName === 'second') {
            // 	this.message = 'session'
            // }
            // console.log("message:"+this.message)
        },
        getDomainData() {
            var _this = this
            this.$nextTick(function () {
                fetch(Config.url + "/api/v1/console/domains")
                .then(res => res.json())
                .then(json => {
                //var result = '{\"version_number\":1,\"domains\":[\"AS\",\"EU\",\"NA\"]}';
                //var json = JSON.parse(result);
                    console.log("getDomainData json:", json);
                    var i;
                    console.log(json.domains)
                    console.log("serverItems:"+_this.serverItems)
                    for (i = 0; i <= json.domains.length - 1; i++) {
                        var label = json.domains[i]
                        var value = json.domains[i]
                        // _this.serverItems[i] = new _this.showServerItems(label, value)
                        _this.$set(_this.serverItems, i, new _this.showServerItems(label, value));
                    }
                    console.log("serverItems:"+_this.serverItems)
                })
            })
        },
        showServerItems(label, value) {
            this.label = label;
            this.value = value;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Area.vue